export default {
  "Personal Development": [
    "Resilience",
    "Purpose",
    "Creativity",
    "Perspective",
  ],

  "Career Progression": [
    "Upskilling",
    "Networking",
    "Pivoting",
    "Freelance",
    "Vision",
  ],

  Leadership: ["HERstory", "Brand You", "Working Environment", "Development"],

  Entrepreneurship: [
    "Funding",
    "Branding",
    "Mindset",
    "Scaling",
    "Practical Skills",
    "Getting Started",
  ],

  Wellbeing: [
    "Financial Wellbeing",
    "Mental Wellbeing",
    "Physical Wellbeing",
    "Work- Life Balance",
    "Motherhood",
  ],

  "Diversity, Equity & Inclusion": [
    "Conscious Inclusion",
    "Recruitment",
    "Culture",
    "Allyship & Advocacy",
  ],

  Tech: ["Web3"],
};
